import { Instagram, Twitter, Youtube } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-black text-white border-t border-white/10">
      <div className="px-6 md:px-12 lg:px-16 pt-20">
        <p className="font-anton text-[18vw] leading-[0.8] uppercase tracking-tight text-white/[0.06] select-none pointer-events-none -mb-[3vw]">
          Jersey Blend
        </p>
      </div>
      <div className="px-6 md:px-12 lg:px-16 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <p className="font-anton text-4xl tracking-tight uppercase">
              Jersey<span className="text-primary">Blend</span>
            </p>
            <p className="text-white/50 mt-4 max-w-sm leading-relaxed">
              Iconic jerseys, reimagined on premium hoodies and tees. Built for sports — designed to blend into any culture.
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-white/40 mb-4">Shop</p>
            <ul className="space-y-2 text-sm text-white/70">
              <li><a href="/#shop" className="hover:text-primary transition-colors">All Products</a></li>
              <li><Link to="/collections/soccer" data-testid="footer-collection-soccer" className="hover:text-primary transition-colors">Soccer Jerseys</Link></li>
              <li><Link to="/collections/nfl" data-testid="footer-collection-nfl" className="hover:text-primary transition-colors">NFL Football</Link></li>
              <li><Link to="/collections/nba" data-testid="footer-collection-nba" className="hover:text-primary transition-colors">NBA Basketball</Link></li>
              <li><Link to="/collections/champions" data-testid="footer-collection-champions" className="hover:text-primary transition-colors">World Champions</Link></li>
              <li><Link to="/blog" data-testid="footer-blog" className="hover:text-primary transition-colors">Guides & Tips</Link></li>
              <li><a href="/#story" className="hover:text-primary transition-colors">Our Story</a></li>
              <li><a href="/#contact" className="hover:text-primary transition-colors">Contact</a></li>
              <li><Link to="/track" data-testid="footer-track-link" className="hover:text-primary transition-colors">Track Order</Link></li>
              <li><Link to="/rewards" data-testid="footer-rewards-link" className="hover:text-primary transition-colors">Rewards</Link></li>
              <li><Link to="/admin" className="hover:text-primary transition-colors">Store Admin</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-white/40 mb-4">Follow</p>
            <div className="flex gap-4">
              <a href="#" className="text-white/70 hover:text-primary transition-colors"><Instagram className="w-5 h-5" /></a>
              <a href="#" className="text-white/70 hover:text-primary transition-colors"><Twitter className="w-5 h-5" /></a>
              <a href="#" className="text-white/70 hover:text-primary transition-colors"><Youtube className="w-5 h-5" /></a>
            </div>
          </div>
        </div>
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between text-xs text-white/40 gap-2">
          <span>© {new Date().getFullYear()} Jersey Blend. All rights reserved.</span>
          <span>Powered by print-on-demand · Printify</span>
        </div>
      </div>
    </footer>
  );
}
